export default {
  fieldData: [],
  plantingOnly: true,
  fieldSearchStatus: 0,
  fieldSearchVariety: '',
  fieldSearchGrade: '',
  fieldSearchRisk: 0,
  fieldSearchText: '',
  accordionType: '1',
  sortOrder: 'harvestForecastDays',
  sort: 'asc',
  fieldSortFlag: true
}
